export default __webpack_public_path__ + "static/media/p31.2a805193.jpg";